import React, { useState, useEffect } from 'react';
import { teamsManager } from '../services/api/managers';
import '../styles/index.css';
import Header from '../components/Header';

const PREMIER_LEAGUE_ID = 39;

const AVAILABLE_SEASONS = [2025, 2024, 2023, 2022, 2021, 2020, 2019];

const TeamsPage = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [dataSource, setDataSource] = useState(null);
  
  const leagueId = PREMIER_LEAGUE_ID;
  
  const [season, setSeason] = useState(2024);
  
  const handleSeasonChange = (e) => {
    setSeason(Number(e.target.value));
  };
  
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      
      try {
        console.log(`Fetching teams for Premier League (${leagueId}), season ${season}`);
        const response = await teamsManager.fetchTeams(leagueId, season);
        
        if (response.status === 'success') {
          setData(response.data);
          
          if (response.source) {
            setDataSource(response.source);
          } else {
            setDataSource({
              fromCache: false,
              fromFile: false,
              timestamp: new Date().toISOString()
            });
          }
        } else {
          setError(response.message || 'Error loading data');
          setData(null);
        }
      } catch (err) {
        console.error('Error fetching teams:', err);
        setError('Error loading teams: ' + (err.message || 'Unknown error'));
        setData(null);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [season]);

  const renderTeams = () => {
    if (!data || !data.response || !data.response.length) {
      return <div className="empty-data">No team data available for the selected season</div>;
    }
    
    return (
      <div className="teams-grid">
        {data.response.map((item) => {
          if (!item || !item.team) return null;
          
          return (
            <div className="team-card" key={item.team.id || `team-${Math.random()}`}>
              <div className="team-logo-container">
                <img 
                  src={item.team.logo} 
                  alt={item.team.name || 'Team'} 
                  className="team-logo"
                  onError={(e) => {e.target.onerror = null; e.target.src = 'https://via.placeholder.com/100?text=No+Logo'}}
                />
              </div>
              <div className="team-details">
                <h3>{item.team.name || 'Unknown Team'}</h3>
                {item.team.founded && <p>Founded: {item.team.founded}</p>}
                <div className="team-country">
                  <span>Country: {item.team.country || 'N/A'}</span>
                  {item.team.national && <span className="national-badge">National</span>}
                </div>
              </div>
              {item.venue && (
                <div className="venue-info">
                  <h4>{item.venue.name || 'Venue unknown'}</h4>
                  {item.venue.capacity && <p>Capacity: {item.venue.capacity.toLocaleString()}</p>}
                  {item.venue.city && <p>City: {item.venue.city}</p>}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="data-page">  
      <Header title="Teams Page" />
      
      <div className="content-container">
        <div className="controls">
          <div className="select-container">
            <label htmlFor="season-select">Season:</label>
            <select
              id="season-select"
              value={season}
              onChange={handleSeasonChange}
              disabled={loading}
            >
              {AVAILABLE_SEASONS.map(year => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>
        </div>

        <h2>Teams in the {season} Season</h2>
        
        {loading ? (
          <div className="loading">Loading teams...</div>
        ) : error ? (
          <div className="error">{error}</div>
        ) : (
          renderTeams()
        )}
      </div>
    </div>
  );
};

export default TeamsPage; 